import type { FaireProductEntity } from "../../entity_types/product";

export const p_e8p9vv37k7: FaireProductEntity = {
  token: "p_e8p9vv37k7",
  type: "product",
  name: "Nutcracker Trellis Christmas Sweatshirt - Kids Clothing",
  brandToken: "b_gro99lye",
  brandName: "Sweet Wink",
  imageUrl:
    "https://cdn.faire.com/fastly/56d4a0af30be99c57db2c89e8bafb55a103cf3c275cb5f86a9f411501e33edef.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d15b2641447559d4b13c14a2b2eac55fec63dd233dbaa2e1bb0d1e3ea2f906b5.jpeg",
    "https://cdn.faire.com/fastly/9620304b18e875a2a949e9b44223daaf622a919f320cd2036b262430d5edab94.jpeg",
    "https://cdn.faire.com/fastly/d843b62098514e1125095945dc5503430216ff4fee721f7212f606c64e3a0ac2.jpeg",
    "https://cdn.faire.com/fastly/e3a0a11084e799501cb41ca9069ad3bc5a0dc6df64e2670278ee4f2675de25af.jpeg",
    "https://cdn.faire.com/fastly/670c87944c19a8550823cc9270ea861f8a650da3f5cf8d4f6c78ab0d6ad5a549.jpeg",
    "https://cdn.faire.com/fastly/a766c2ebb55cab984d95d6b8a966dcb395dbf2670713a2e937ab274986361112.jpeg",
    "https://cdn.faire.com/fastly/fe9c8e8eaf784e6e4787074f3f9e8c6f71a968348d167aa338417c1ec6257b76.jpeg",
  ],
  priceDollars: 19,
  description:
    "The Nutcracker Trellis Christmas Sweatshirt is a fun and festive sweatshirt for celebrating Christmas!\n\nFeatures:\n*Crewneck Color: Ballet Pink\n*Graphic Color: Multicolor\n*Material: 60% Cotton/40% Polyester\n*Features: Tagless inside neck label for an itch-free wear\n*Fit: Toddler Unisex; True to Size\n*Care: Machine wash cold inside out, only non-chlorine bleach, tumble dry low, do not iron on decoration, do not dry clean\n\nEach sweatshirt is packed with love in our hometown warehouse.",
  tags: [],
  msrpDollars: 38,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:26:42.649Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
